import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AgencyV2ClientPageLayout } from 'components/layouts/AgencyV2ClientPageLayout'

import AudioUploader from '../AudioUploader'

interface AgencyV2UploadAudioPageParams {
  step: string
}

enum AgencyV2UploadAudioStep {
  Upload = 'upload'
}

export const AgencyV2CreateAdAudioPage = () => {
  const { step } = useParams<AgencyV2UploadAudioPageParams>()
  const [helmetTitle, setHelmetTitle] = useState('')
  const [panelTitle, setPanelTitle] = useState('')

  useEffect(() => {
    switch (step) {
      case AgencyV2UploadAudioStep.Upload:
        setHelmetTitle('Upload Streaming Audio Ad')
        setPanelTitle('Upload Streaming Audio Ad')
        break
    }
  }, [step])

  return (
    <AgencyV2ClientPageLayout helmetTitle={helmetTitle} panelTitle={panelTitle}>
      {step === AgencyV2UploadAudioStep.Upload && <AudioUploader />}
    </AgencyV2ClientPageLayout>
  )
}
